import React from 'react';
import { Box, Typography } from '@mui/material';
import { MdOutlinePhone } from "react-icons/md";
import './ContactInfo.scss';
import { useNavigate } from 'react-router-dom';
const ContactInfo = ({ phoneNumber,logo, logo2,t ,direction}) => {
  const navigate = useNavigate(); 

  const handleLogoClick = () => {
    navigate('/'); 
  };

  return (
    <Box className="contact-info" >
        <a  className="contact-phone-link">
      <Box className="contact-phone" >
        <Box className="contact-phone-icon" >
          <MdOutlinePhone />
        </Box>

        <Box className="contact-details" sx={direction={direction}}>
          <Typography className="contact-title"> {t.contactUs}</Typography>
          <a  className="contact-number">{phoneNumber}</a> {/* Making the number a clickable link to make the call */}
        </Box>
      </Box>
      </a>

      {/* Divider between phone details and logo */}
      <Box className="contact-divider" />

      {/* Conditionally render logo based on screen size */}
      <Box
        component="img"
        src={logo} 
         loading="lazy"
        alt="Awen Logo"
        className="contact-logo"
        onClick={handleLogoClick}
      
      />
     
    </Box>
  );
};

export default ContactInfo;
